import { ShopperAgentChannelsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/channel-config";
import { ShopperAgentEmailConfigSchema } from "@redotech/redo-shopper-agent-settings-common/email-config";
import { ShopperAgentRcsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/rcs-config";
import { ShopperAgentSupervisorConfigSchema } from "@redotech/redo-shopper-agent-settings-common/supervisor-config";
import * as z from "zod";

export const updateBaseShopperAgentSettings = {
  name: "updateBaseShopperAgentSettings" as const,
  input: z.object({
    enabled: z.boolean().optional(),
    iMessageConfig: z.object({ enabled: z.boolean().optional() }).optional(),
    rcsConfig: ShopperAgentRcsConfigSchema.optional(),
    emailConfig: ShopperAgentEmailConfigSchema.optional(),
    personaConfig: z.object({ name: z.string().optional() }).optional(),
    recoverConfig: z.object({ enabled: z.boolean().optional() }).optional(),
    replyConfig: z.object({ enabled: z.boolean().optional() }).optional(),
    supervisorConfig: ShopperAgentSupervisorConfigSchema.nullable().optional(),
    channels: ShopperAgentChannelsConfigSchema.optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
